<template>
  <v-container fluid class="my-v-container">
    <v-app-bar app elevation="0" color="var(--bg-color)">
      <sea-plus-nav-icon></sea-plus-nav-icon>
    </v-app-bar>
    <v-card width="600" class="my-v-card">
      <v-card-title>Thank you</v-card-title>
      <v-card-subtitle>購入ありがとうございました。</v-card-subtitle>
      <v-card-actions>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="openHome">ホーム</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import SeaPlusNavIcon from '@/components/SeaPlusNavIcon.vue'
import { STORAGE_KEY_COUPON_CODE } from './SelectPlan.vue'

export default {
  components: {
    SeaPlusNavIcon
  },
  methods: {
    openHome() {
      this.$router.replace('/?checkout=success')
    }
  },
  mounted() {
    localStorage.removeItem(STORAGE_KEY_COUPON_CODE)
  }
}
</script>
